import template from './propertyTypeSelection.html';
import controller from './propertyTypeSelectionCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
  },
};
